import { render, staticRenderFns } from "./zichan.vue?vue&type=template&id=95b7def6&scoped=true"
import script from "./zichan.vue?vue&type=script&lang=js"
export * from "./zichan.vue?vue&type=script&lang=js"
import style0 from "./zichan.vue?vue&type=style&index=0&id=95b7def6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b7def6",
  null
  
)

export default component.exports